import { isLastItem, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getAccordianChildStyle = (showTooltipRight, showTooltipLeft, isLargeScreen, index, list) => {
  return StyleSheet.create({
    singleContainerWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
      paddingRight: showTooltipRight ? tokens.spacing.SPACING_0 : tokens.spacing.SPACING_28
    },
    singleElementWrapper: Object.assign(Object.assign({
      flex: 1,
      flexBasis: 'auto',
      display: 'flex',
      flexDirection: 'column'
    }, !isLastItem(list, index) && {
      marginBottom: tokens.spacing.SPACING_8
    }), {
      marginRight: tokens.spacing.SPACING_8,
      alignItems: 'flex-start'
    }),
    singleElementWrapperRight: Object.assign({
      flex: 1,
      flexBasis: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    }, !isLastItem(list, index) && {
      marginBottom: tokens.spacing.SPACING_8
    }),
    subTextWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginBottom: tokens.spacing.SPACING_4,
      paddingRight: showTooltipRight ? tokens.spacing.SPACING_28 : tokens.spacing.SPACING_0
    },
    singleItemComponent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: tokens.spacing.SPACING_4
    },
    singleItemRightComponent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    },
    singleItemRightText: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      flex: 1,
      flexBasis: 'auto',
      paddingRight: showTooltipRight ? tokens.spacing.SPACING_8 : tokens.spacing.SPACING_0
    },
    singleItemLeftText: {
      marginRight: showTooltipLeft ? tokens.spacing.SPACING_4 : tokens.spacing.SPACING_0
    },
    toolTipStyle: {
      paddingHorizontal: isLargeScreen ? tokens.spacing.SPACING_2 : tokens.spacing.SPACING_4
    },
    infoTagContainer: {
      marginBottom: tokens.spacing.SPACING_4
    },
    infoTagWrapperStyles: {
      paddingVertical: tokens.spacing.SPACING_4,
      marginRight: showTooltipRight ? tokens.spacing.SPACING_28 : tokens.spacing.SPACING_0
    }
  });
};